module.exports = __webpack_public_path__ + "img/exercise_test-5.1d3b9b2b.png";